export const meta = {
  slug: { de: "terminabsagen-reduzieren-praxis", en: "reduce-appointment-cancellations" },
  title: "Terminabsagen und Nichterscheinen ruhig reduzieren",
  excerpt:
    "Kurzfristige Absagen und nicht wahrgenommene Termine kosten Praxen täglich Zeit. Strukturen helfen mehr als Druck oder Strafgebühren.",
  category: "praxen",
  publishedAt: "2026-04-13",
  metaTitle: "Terminabsagen in Praxen reduzieren | OnePractix",
  metaDescription:
    "Wie Praxen Terminabsagen und Nichterscheinen ruhig reduzieren: durch klare Buchungslogik, Erinnerungen und eine verlässliche Patientenführung.",
  related: ["digitale-terminvergabe-praxis-vorteile", "praxisorganisation-verbessern"],
  en: {
    title: "Calmly reducing cancellations and no-shows",
    metaTitle: "Reducing cancellations in medical practices | OnePractix",
    metaDescription:
      "How practices calmly reduce cancellations and no-shows: through clear booking logic, reminders and reliable patient guidance.",
    excerpt:
      "Short-notice cancellations and missed appointments cost practices time every day. Structures help more than pressure or penalty fees.",
  },
};

export default meta;
